import { AI_FIELD_NAVIGATION_ATTRIBUTES } from '../constants';
import { AiNavigationAttributes } from '../types';

const mergeNavigationAttributes = (
  ...attributes: AiNavigationAttributes[]
): AiNavigationAttributes => {
  const joinedAttributes = attributes
    .map((attribute) => attribute[AI_FIELD_NAVIGATION_ATTRIBUTES])
    .join(',');

  return { [AI_FIELD_NAVIGATION_ATTRIBUTES]: joinedAttributes };
};

export { mergeNavigationAttributes };
